import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Web from "./pages/Web";
import LoginPage from "./pages/Login";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import React from "react";
import Dashboard from "./pages/dashboard/Dashboard";
import CustomerList from "./pages/CustomersList";
import CustomerForm from "./pages/CustomersForm";
import ProductsList from "./pages/ProductsList";
import ProductsForm from "./pages/ProductsForm";
import WarehousesList from "./pages/WarehousesList";
import WarehousesForm from "./pages/WarehousesForm";
import ZonesList from "./pages/ZonesList";
import ZonesForm from "./pages/ZonesForm";
import LocationList from "./pages/LocationsList";
import LocationForm from "./pages/LocationsForm";
import InboundOrdersList from "./pages/InboundOrdersList";
import InboundOrdersForm from "./pages/InboundOrdersForm";
import OutboundOrdersList from "./pages/OutboundOrdersList";
import OutboundOrdersForm from "./pages/OutboundOrdersForm";
import VendorsList from "./pages/VendorsList";
import VendorsForm from "./pages/VendorsForm";
import ProductsPriceList from "./pages/ProductsPriceList";
import ProductsPriceForm from "./pages/ProductsPriceForm";
import Unauthorized from "./pages/Unauthorized";
import SalesOrdersList from "./pages/SalesOrdersList";
import SalesOrdersForm from "./pages/SalesOrdersForm";
import UomsList from "./pages/UomsList";
import UomsForm from "./pages/UomsForm";
import CategoriesList from "./pages/CategoriesList";
import CategoriesForm from "./pages/CategoriesForm";
import PutawayOutstandingList from "./pages/PutawayOutstandingList";
import PutawayHistoryList from "./pages/PutawayHistoryList";
import PickingOutstandingList from "./pages/PickingOutstandingList";
import PickingHistoryList from "./pages/PickingHistoryList";
import ShippingOrdersList from "./pages/ShippingOrdersList";
import ShippingOrdersForm from "./pages/ShippingOrdersForm";
import StockList from "./pages/StocksList";
import StockMovementList from "./pages/StockMovementsList";
import DashboardSales from "./pages/Dashboard-Sales";
import DashboardInboundOutbound from "./pages/Dashboard-Inbound-Outbound";
import DashboardInventory from "./pages/Dashboard-Inventory";

import { ROLES } from "./constants/roles";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/customer" element={<Navigate to="/customers" replace />} />
		  <Route path="/web" element={<Web />} />

          <Route element={<ProtectedRoute allowedRoles={[
            ROLES.SUPERADMIN,
			ROLES.ADMIN_SALES,
			ROLES.SALES,
            ROLES.ADMIN,            
            ROLES.OPERATOR,
			ROLES.SUPERVISOR,
          ]}><Layout /></ProtectedRoute>}>
            
			
            {/* Universal Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />

			<Route path="/dashboard-transaction" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><DashboardInboundOutbound /></ProtectedRoute>} />
			<Route path="/dashboard-inventory" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><DashboardInventory /></ProtectedRoute>} />
			<Route path="/dashboard-productivity" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><Dashboard /></ProtectedRoute>} />

            {/* Superadmin-only */}
            <Route path="/tenant" element={<ProtectedRoute allowedRoles={[ROLES.SUPERADMIN]}><div>Tenant Page</div></ProtectedRoute>} />
            <Route path="/user" element={<ProtectedRoute allowedRoles={[ROLES.SUPERADMIN]}><div>User Page</div></ProtectedRoute>} />

            {/* Customers */}
            <Route path="/customers" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><CustomerList /></ProtectedRoute>} />
            <Route path="/customers/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><CustomerForm /></ProtectedRoute>} />
            <Route path="/customers/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><CustomerForm /></ProtectedRoute>} />

            {/* Vendors */}
            <Route path="/vendors" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><VendorsList /></ProtectedRoute>} />
            <Route path="/vendors/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><VendorsForm /></ProtectedRoute>} />
            <Route path="/vendors/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><VendorsForm /></ProtectedRoute>} />

            {/* Products */}
            <Route path="/products" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><ProductsList /></ProtectedRoute>} />
            <Route path="/products/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><ProductsForm /></ProtectedRoute>} />
            <Route path="/products/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><ProductsForm /></ProtectedRoute>} />

            {/* Products Price */}
            <Route path="/products-price" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SUPERADMIN]}><ProductsPriceList /></ProtectedRoute>} />
            <Route path="/products-price/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SUPERADMIN]}><ProductsPriceForm /></ProtectedRoute>} />
            <Route path="/products-price/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SUPERADMIN]}><ProductsPriceForm /></ProtectedRoute>} />

            {/* Sales Orders */}
            <Route path="/sales-orders" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.SUPERADMIN]}><SalesOrdersList /></ProtectedRoute>} />
            <Route path="/sales-orders/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.SUPERADMIN]}><SalesOrdersForm /></ProtectedRoute>} />
            <Route path="/sales-orders/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.SUPERADMIN]}><SalesOrdersForm /></ProtectedRoute>} />

            {/* Inbound Orders */}
            <Route path="/inbound-orders" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><InboundOrdersList /></ProtectedRoute>} />
            <Route path="/inbound-orders/create" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><InboundOrdersForm /></ProtectedRoute>} />
            <Route path="/inbound-orders/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><InboundOrdersForm /></ProtectedRoute>} />
			
			{/* Outbound Orders */}
            <Route path="/outbound-orders" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><OutboundOrdersList /></ProtectedRoute>} />
			<Route path="/outbound-orders/create" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><OutboundOrdersForm /></ProtectedRoute>} />
            <Route path="/outbound-orders/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><OutboundOrdersForm /></ProtectedRoute>} />
									
			{/* Putaway Tasks (from Inbound ) */}
			<Route path="/putaway-outstanding" element={ <ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><PutawayOutstandingList /></ProtectedRoute>}/>
			<Route path="/putaway-history" element={ <ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><PutawayHistoryList /></ProtectedRoute>}/>
			
			{/* Picking Tasks (from Outbound ) */}
			<Route path="/picking-outstanding" element={ <ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><PickingOutstandingList /></ProtectedRoute>}/>
			<Route path="/picking-history" element={ <ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><PickingHistoryList /></ProtectedRoute>}/>
			
			{/* Shipping Orders */}
            <Route path="/shipping-orders" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><ShippingOrdersList /></ProtectedRoute>} />
			<Route path="/shipping-orders/create" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><ShippingOrdersForm /></ProtectedRoute>} />
            <Route path="/shipping-orders/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><ShippingOrdersForm /></ProtectedRoute>} />
			
			{/* Stock */}
			<Route path="/stocks" element={ <ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><StockList /></ProtectedRoute>}/>
			<Route path="/stock-movements" element={ <ProtectedRoute allowedRoles={[ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERADMIN]}><StockMovementList /></ProtectedRoute>}/>

            {/* Warehouse */}
            <Route path="/warehouse" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><WarehousesList /></ProtectedRoute>} />
            <Route path="/warehouse/create" element={<ProtectedRoute allowedRoles={[ROLES.SUPERADMIN]}><WarehousesForm /></ProtectedRoute>} />
            <Route path="/warehouse/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><WarehousesForm /></ProtectedRoute>} />

            {/* Zones */}
            <Route path="/zone" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><ZonesList /></ProtectedRoute>} />
            <Route path="/zone/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><ZonesForm /></ProtectedRoute>} />
            <Route path="/zone/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN]}><ZonesForm /></ProtectedRoute>} />

            {/* Locations */}
            <Route path="/locations" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><LocationList /></ProtectedRoute>} />
            <Route path="/locations/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><LocationForm /></ProtectedRoute>} />
            <Route path="/locations/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.ADMIN, ROLES.SUPERADMIN]}><LocationForm /></ProtectedRoute>} />

			{/* UoM */}
			<Route path="/uoms" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.ADMIN_SALES]}><UomsList /></ProtectedRoute>} />
			<Route path="/uoms/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.ADMIN_SALES]}><UomsForm /></ProtectedRoute>} />
			<Route path="/uoms/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.ADMIN_SALES]}><UomsForm /></ProtectedRoute>} />
			
			{/* Categories */}
			<Route path="/categories" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.ADMIN_SALES]}><CategoriesList /></ProtectedRoute>} />
			<Route path="/categories/create" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.ADMIN_SALES]}><CategoriesForm /></ProtectedRoute>} />
			<Route path="/categories/edit/:id" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.ADMIN_SALES]}><CategoriesForm /></ProtectedRoute>} />

            {/* Dashboard Sales */}
            <Route path="/dashboard-sales" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN_SALES, ROLES.SALES, ROLES.SUPERADMIN]}><DashboardSales /></ProtectedRoute>} />
			
			<Route path="/unauthorized" element={<Unauthorized />} />

          </Route>
		  
		  <Route path="/" element={<Navigate to="/web" replace />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
